module.exports = __webpack_public_path__ + "card3-v1.f17f457fcca76c0befa96c44e8700207.jpg";